import React, { FC, useState } from 'react';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { PaymentDetails } from '~/types';
import { cleanupFormValues } from '~/utils';
import PaymentDetailsForm from './PaymentDetailsForm';
import { paymentDetails } from '~/routes';
import { FormDrawer } from '~/components';
import { usePermissions } from '~/hooks';
import { usePaymentDetailsEdit } from '~/hooks/paymentDetails';

interface PaymentDetailsEditProps {
  initialValues: PaymentDetails;
}

const PaymentDetailsEdit: FC<PaymentDetailsEditProps> = (props) => {
  const { initialValues = {} } = props;
  const [t] = useTranslation('paymentDetails');
  const dt = (key: string): string => t(`translation:${key}`);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const { mutate, isLoading } = usePaymentDetailsEdit(handleClose);

  const onFinish = (values: PaymentDetails) => {
    mutate({
      id: initialValues.id as string,
      body: cleanupFormValues({ ...initialValues, ...values }),
    });
  };

  const hasAccess = usePermissions('business.paymentDetails.update');
  if (!hasAccess) return null;
  return (
    <>
      <Button onClick={handleOpen} type="primary">
        {dt('edit')}
      </Button>
      <FormDrawer
        name={paymentDetails}
        onFinish={onFinish}
        loading={isLoading}
        title={t('editPaymentDetails', { name: initialValues.name })}
        onClose={handleClose}
        visible={open}
      >
        <PaymentDetailsForm name={paymentDetails} initialValues={initialValues} edit />
      </FormDrawer>
    </>
  );
};

export default PaymentDetailsEdit;
